import { SkeletonBlock, SkeletonText, Text } from "@zapier/design-system";
import styles from "./ZapBreakdown.module.css";

export const ZapBreakdownSkeleton = () => {
  return (
    <div className={styles.zapBreakdownWrapper} data-testid="zap-breakdown">
      <div className={styles.zapBreakdownContainer}>
        <div className={styles.title}>
          <div className={styles.servicesArea}>
            <div className={styles.serviceIconsSkeleton}>
              <SkeletonBlock width={36} height={36} />
              <SkeletonBlock width={36} height={36} />
            </div>
          </div>
          <SkeletonText lines={1} size="body" />
        </div>

        <div className={styles.detailsLabel}>
          <Text type="Body4">Zap details:</Text>
        </div>

        <div className={styles.skeletonStepsContainer}>
          <div className={styles.skeletonStep}>
            <SkeletonBlock width={24} height={24} />
            <SkeletonText lines={1} size="body" />
          </div>
          <div className={styles.skeletonStep}>
            <SkeletonBlock width={24} height={24} />
            <SkeletonText lines={1} size="body" />
          </div>
        </div>
      </div>
    </div>
  );
};
